<form [formGroup]="loginForm" (ngSubmit)="Continuar($event)" (change)="onChangeForm($event)">
    <div class="persona-juridica">
        <div class="row">
            <!-- RUT -->
            <div class="col-md-12 txt-rut form-group">
                <label for="txtRut" class="mb-0">RUT (sin puntos ni guión)</label>

                <!-- <div class="label-right" 
                    [popper]="mensajesErrorLogin.RUT_INFO_TOOLTIP"
                    [popperPlacement]="'bottom-end'" 
                    [popperTrigger]="'hover'" 
                    [popperHideOnClickOutside]="true"
                    [popperHideOnScroll]="true" 
                    [popperApplyClass]="'popperstyle-blue'">
                    Info &nbsp;
                    <i class="informativo-blue"></i>
                </div> -->

                <input tabindex="2" 
                    appFormatRut 
                    [ngClass]="{
                        inputValido: rutControl.valid,
                        inputInvalido:
                            (rutControl.invalid && rutControl.touched) || 
                            (rutControl.invalid && rutControl.dirty)
                    }" 
                    type="text" 
                    name="txtRut" 
                    formControlName="txtRut" 
                    placeholder="Ej 123456789" 
                    autocomplete="on"
                    (focusout)="checkInput('txtRut')" />
                    
                <div *ngFor="let validation of messageRescatarDataError.txtRut">
                    <p *ngIf="
                        rutControl.hasError(validation.type) &&
                        (rutControl.dirty || rutControl.touched)
                    " 
                    class="mensajeError mb-0">
                        {{ validation.message }}
                    </p>
                </div>
            </div>

            <!-- EMAIL -->
            <div class="col-md-12 form-group">
                <label for="correoElectronico" class="mb-0">Email</label>
                <input type="text" tabindex="3"
                    [ngClass]="{
                inputValido: correoControl.valid,
                inputInvalido: (correoControl.invalid && correoControl.touched) || (correoControl.invalid && correoControl.dirty)}" name="correo"
                    placeholder="Ej correo@mail.com" (focusout)="checkInput('txtCorreo')" appMaxLength="40"
                    autocomplete="on" formControlName="txtCorreo" oninput="this.value = this.value.toLowerCase()" />
                <p *ngIf="correoControl.touched && correoControl.errors?.required" class="mensajeError mb-0">Ingrese un
                    email
                </p>
                <p *ngIf="correoControl.touched && correoControl.errors?.pattern" class="mensajeError mb-0">{{
                    mensajesErrorLogin.REQUIRED_EMAIL_MESSAGE }}</p>
            </div>
            
            <!-- CONFIRMAR EMAIL -->
                <div class="col-md-12 form-group">
                <label for="confirmCorreoElectronico" class="mb-0">Confirmar Email</label>
                <input type="text" tabindex="3"
                    [ngClass]="{
                    inputValido: confirmarCorreoControl.valid && correoControl.value === confirmarCorreoControl.value,
                    inputInvalido: (confirmarCorreoControl.touched || confirmarCorreoControl.dirty) && correoControl.value !== confirmarCorreoControl.value
                    }"
                    name="confirmCorreo"
                    placeholder="Reingresar su correo"
                    autocomplete="new-password"
                    formControlName="txtCorreoConfirm"
                    oninput="this.value = this.value.toLowerCase()"
                    (focusout)="checkInput('txtCorreoConfirm')"
                    (paste)="bloquearEvento($event)"
                    (copy)="bloquearEvento($event)"
                    (cut)="bloquearEvento($event)"
                    (contextmenu)="bloquearEvento($event)"
                    (drop)="bloquearEvento($event)"
                    (dragover)="bloquearEvento($event)"
                    draggable="false"
                    readonly
                    (focus)="removeReadonly($event)"
                />
               <p class="mensajeError mb-0" *ngIf="confirmarCorreoControl.touched && confirmarCorreoControl.invalid">
                <ng-container *ngIf="confirmarCorreoControl.errors?.required; else noCoinciden">
                    Debe confirmar su email
                </ng-container>
                <ng-template #noCoinciden>
                    <span *ngIf="correoControl.value !== confirmarCorreoControl.value">
                    Los correos no coinciden
                    </span>
                </ng-template>
                </p>
                </div>


            <!-- TELEFONO -->
            <div class="col-md-12 form-group">
                <label for="telefono" class="mb-0">Teléfono</label>
                <span class="prefijo">+56</span>
                <input appNumeros type="text" tabindex="4" class="pre-input"
                    [ngClass]="{
                inputValido: telefonoControl.valid,
                inputInvalido: (telefonoControl.invalid && telefonoControl.touched) || (telefonoControl.invalid && telefonoControl.dirty)}" name="telefono"
                    formControlName="txtTelefono" placeholder="Ingresar 9 dígitos" autocomplete="on"
                    appMaxLength="9" [class.inputInvalido]="
                telefonoControl.invalid &&
                (telefonoControl.touched || telefonoControl.dirty)
              " required (focusout)="checkInput('txtTelefono')" />
                <p class="text-danger" *ngIf="
                (telefonoControl.touched || telefonoControl.dirty) &&
                (telefonoControl.errors?.appMaxLength ||
                  telefonoControl.errors?.pattern)
              " class="mensajeError">
                    {{ mensajesErrorLogin.INVALID_PHONE_MESSAGE }}
                </p>
                <p class="text-danger" *ngIf="
                (telefonoControl.touched || telefonoControl.dirty) &&
                telefonoControl.errors?.required
              " class="mensajeError">
                    {{ mensajesErrorLogin.REQUIRED_PHONE_MESSAGE }}
                </p>
            </div>

            <!-- CHECKBOXES -->
            <div class="col-md-12 my-30 terminos-condiciones">
                <mat-checkbox [disabled]="telefonoControl.invalid || correoControl.invalid || rutControl.invalid"
                    tabindex="4" formControlName="autorizacion">
                    He leído y acepto los <a href="{{urlTerminos}}" rel="noopener noreferrer" target="_blank">Términos y
                        condiciones</a> de Transbank.
                </mat-checkbox>
                <mat-checkbox [disabled]="telefonoControl.invalid || correoControl.invalid || rutControl.invalid"
                    tabindex="4" formControlName="autorizacion2">
                    He leído y acepto la <a href="{{urlPrivacidad}}" rel="noopener noreferrer" target="_blank">Política
                        de privacidad</a> y autorizo a Transbank a hacer tratamiento de mis datos personales de acuerdo
                    a la Ley vigente.
                </mat-checkbox>
            </div>

            <!-- MENSAJES COMPLETITUD DATOS -->
            <div class="row">
                <div *ngIf="authControl.dirty && !authControl.valid || authControl2.dirty && !authControl2.valid"
                    class="col-md-12 box-mensaje-error">
                    <app-messages class="error mt-16"
                        message="Es necesario aceptar los términos de condiciones y la política de privacidad para continuar">
                    </app-messages>
                </div>
            </div>

            <div class="col-md-12 form-group txt--right">
                <button tabindex="5" class="btn-primary-tbk" type="submit" value="Continuar"
                    [disabled]="loginForm.invalid || loginForm.invalid">
                    <div *ngIf="loading" class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!loading">Continuar</div>
                </button>
            </div>
        </div>
    </div>
</form>